<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">官网APP管理</p>
    <div class="main-container">
      <div class="handle-area">
        <div class="handle-button">
          <Button v-if="!editable" type="primary" @click="openDrag">拖拽排序</Button>
          <Button v-else type="primary" @click="completeDrag">完成排序</Button>
          <Button v-if="editable" @click="orderList">重置排序</Button>
        </div>
      </div>
      <div class="main-area">
        <Card class="sub-area">
          <p slot="title">官网一级展示区产品内容</p>
          <a href="javascript:void(0)" slot="extra" @click="createApp(1, productInfoArea1.length)" style="margin-right: 20px">添加应用</a>
          <draggable v-model="productInfoArea1" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group class="list-group" type="transition" tag="ul">
              <li class="list-group-item" v-for="(item, index) in productInfoArea1" :key="item.id">
                <Card class="app-content">
                  <div class="app-logo">
                    <img :src="item.appLogo">
                  </div>
                  <div class="app-info">
                    <span style="font-size: 16px; font-weight: bold">{{item.productTitle}}</span><br>
                    <span>应用版本: {{item.appVersion}}</span><br>
                    <span>上架时间: {{transDate(item.createDate)}}</span><br>
                    <span>下载量: {{item.downloadCount}}</span>
                  </div>
                  <div class="app-handle">
                    <Button type="primary" @click="showAppDetail(item.areaId, index)">应用详情</Button>
                    <Button type="primary" @click="updateApp(item.areaId, index)">更新版本</Button>
                    <Button type="error" v-if="item.active === 1" @click="appDown(item.areaId, index)">下架应用</Button>
                    <Button type="primary" v-else @click="appUp(item.areaId, index)">上架应用</Button>
                    <Button type="error" @click="deleteApp(item.areaId, index)">删除应用</Button>
                  </div>
                </Card>
              </li>
            </transition-group>
          </draggable>
        </Card>
        <Card class="sub-area">
          <p slot="title">官网二级展示区产品内容</p>
          <a href="javascript:void(0)" slot="extra" @click="createApp(2, productInfoArea2.length)" style="margin-right: 20px">添加应用</a>
          <draggable v-model="productInfoArea2" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" tag="ul" class="list-group">
              <li class="list-group-item" v-for="(item, index) in productInfoArea2" :key="item.id">
                <Card class="app-content">
                  <div class="app-logo">
                    <img :src="item.appLogo">
                  </div>
                  <div class="app-info">
                    <span style="font-size: 16px; font-weight: bold">{{item.productTitle}}</span><br>
                    <span>应用版本: {{item.appVersion}}</span><br>
                    <span>上架时间: {{transDate(item.createDate)}}</span><br>
                    <span>下载量: {{item.downloadCount}}</span>
                  </div>
                  <div class="app-handle">
                    <Button type="primary" @click="showAppDetail(item.areaId, index)">应用详情</Button>
                    <Button type="primary" @click="updateApp(item.areaId, index)">更新版本</Button>
                    <Button type="error" v-if="item.active === 1" @click="appDown(item.areaId, index)">下架应用</Button>
                    <Button type="primary" v-else @click="appUp(item.areaId, index)">上架应用</Button>
                    <Button type="error" @click="deleteApp(item.areaId, index)">删除应用</Button>
                  </div>
                </Card>
              </li>
            </transition-group>
          </draggable>
        </Card>
        <Card class="sub-area">
          <p slot="title">官网三级展示区产品内容</p>
          <a href="javascript:void(0)" slot="extra" @click="createApp(3, productInfoArea3.length)" style="margin-right: 20px">添加应用</a>
          <draggable v-model="productInfoArea3" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group class="list-group" type="transition" tag="ul">
              <li class="list-group-item" v-for="(item, index) in productInfoArea3" :key="item.id">
                <Card class="app-content">
                  <div class="app-logo">
                    <img :src="item.appLogo">
                  </div>
                  <div class="app-info">
                    <span style="font-size: 16px; font-weight: bold">{{item.productTitle}}</span><br>
                    <span>应用版本: {{item.appVersion}}</span><br>
                    <span>上架时间: {{transDate(item.createDate)}}</span><br>
                    <span>下载量: {{item.downloadCount}}</span>
                  </div>
                  <div class="app-handle">
                    <Button type="primary" @click="showAppDetail(item.areaId, index)">应用详情</Button>
                    <Button type="primary" @click="updateApp(item.areaId, index)">更新版本</Button>
                    <Button type="error" v-if="item.active === 1" @click="appDown(item.areaId, index)">下架应用</Button>
                    <Button type="primary" v-else @click="appUp(item.areaId, index)">上架应用</Button>
                    <Button type="error" @click="deleteApp(item.areaId, index)">删除应用</Button>
                  </div>
                </Card>
              </li>
            </transition-group>
          </draggable>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
    import draggable from "vuedraggable";
    import {adminRouter} from "../../router/admin";
    import {format2Sec} from "../../utils/format";
    export default {
        name: "webAPP",
        components: {
            draggable
        },
        data() {
            return {
                productInfo: {},
                productInfoArea1: [],
                productInfoArea2: [],
                productInfoArea3: [],
                editable: false,
                isDragging: false,
                delayedDragging: false
            };
        },
        methods: {
            transDate(time){
                return format2Sec(time);
            },
            orderList() {
                this.productInfoArea1 = this.productInfo.productInfoArea1;
                this.productInfoArea2 = this.productInfo.productInfoArea2;
                this.productInfoArea3 = this.productInfo.productInfoArea3;
            },
            onMove({ relatedContext, draggedContext }) {
                const relatedElement = relatedContext.element;
                const draggedElement = draggedContext.element;
                return (
                    (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
                );
            },
            openDrag(){
                this.editable = true;
            },
            completeDrag(){
                this.editable = false;
                for (let i = 1; i <=3; i++){
                    this.changeOrder(this['productInfoArea' + i], i);
                    this['productInfoArea' + i].forEach((item) => {
                        this.setData(item);
                    });
                }
                this.$Message.success('完成排序！');
            },
            changeOrder(list, area){
              list.map((item, index) => {
                  item.areaId = area;
                  item.sortId = index + 1;
                  return item;
              });
            },
            createApp(areaId, length){
              let active = 'editWebAppDetail';
              let currentTag = localStorage.getItem('currentTag');
              if (currentTag !== active){
                  let tags = null;
                  for (let ele of adminRouter){
                      if (ele.name === active){
                          tags = {
                              title: ele.title,
                              name: ele.name,
                              path: ele.path
                          };
                          break;
                      } else {
                          if (ele.children.length){
                              for (let val of ele.children){
                                  if (val.name === active){
                                      tags = {
                                          title: val.title,
                                          name: val.name,
                                          path: val.path
                                      };
                                      break;
                                  }
                              }
                          }
                      }
                  }
                  localStorage.setItem("currentTag", active);
                  localStorage.setItem("areaId", areaId);
                  localStorage.setItem("sortOrder", '');
                  localStorage.setItem("length", length);
                  this.$store.commit("updateCurrentTag", active);
                  this.$store.commit("updateOpenedTags", [tags]);
                  this.$store.commit("updateCurrentPath", active);
                  this.$router.push({
                      name: active,
                  });
              }
            },
            showAppDetail(areaId, order){
                let active = 'webAppDetail';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("areaId", areaId);
                    localStorage.setItem("sortOrder", order);
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active
                    });
                }
            },
            updateApp(areaId, order){
                let active = 'editWebAppDetail';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("areaId", areaId);
                    localStorage.setItem("sortOrder", order);
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active
                    });
                }
            },
            appUp(areaId, order){
                let tempObj = this['productInfoArea'+areaId][order];
                tempObj.active = 1;
                this.setData(tempObj);
            },
            appDown(areaId, order){
                let tempObj = this['productInfoArea'+areaId][order];
                tempObj.active = 0;
                this.setData(tempObj);
            },
            deleteApp(areaId, order){
                let id = this['productInfoArea'+areaId][order].id;
                this.$http.post('/zm/WMWebsite/deleteProductInfo', {'id': id}).then(
                    res => {
                        this.$Message.success("成功删除！");
                        this['productInfoArea'+areaId].splice(order, 1);
                        this.changeOrder(this['productInfoArea'+areaId], areaId);
                        this['productInfoArea' + areaId].forEach((item) => {
                            this.setData(item);
                        });
                    },
                    err => {
                        this.$Message.error("提交失败！"+err.message);
                    }
                );
            },
            setData(obj){
                this.$http.post('/zm/WMWebsite/updateProductInfo', obj).then(
                    res => {
                    },
                    err => {
                        this.$Message.error("提交失败！"+err.message);
                    }
                );
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: !this.editable,
                    ghostClass: "ghost"
                };
            }
        },
        watch: {
            isDragging(newValue) {
                if (newValue) {
                    this.delayedDragging = true;
                    return;
                }
                this.$nextTick(() => {
                    this.delayedDragging = false;
                });
            }
        },

        activated() {
            this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(
                res => {
                    let tempData = res.data.content;
                    this.productInfo = tempData;
                    for (let i = 1; i <=3; i++){
                        this['productInfoArea'+i] = tempData['productInfoArea'+i];
                    }
                }
            );
        }
    };
</script>

<style>
  .main-container{
    background-color: #eeeeee;
    position: relative;
    width: 80%;
    margin-left: 10%;
  }
  .handle-area{
    width: 100%;
    position: relative;
    display: inline-block;
    background-color: whitesmoke;
  }
  .handle-button{
    float: right;
    position: relative;
    display: inline-block;
    margin: 8px 10px;
  }
  .handle-button button{
    margin-left: 6px;
  }
  .main-area{
    width: 100%;
    position: relative;
    display: inline-block;
  }
  .sub-area{
    width: 100%;
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
  }
  .sub-area .ivu-card-body{
    padding: 10px;
  }
  .sub-area .ivu-card-head p{
    font-size: 16px;
  }
  .list-group{
    list-style-type: none;
    min-height: 100px;
  }
  .sub-area .list-group-item{
    margin-bottom: 5px;
    border: 1px solid #eeeeee;
  }
  .app-content .ivu-card-body{
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    padding: 5px;
    min-height: 100px;
  }
  .app-logo img{
    width: 100px;
    height: 100px;
  }
  .app-info{
    margin-left: 30px;
  }

  .app-handle{
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
  }

  .app-handle button{
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// webAPP.vue?9b37c11c